import Button from '../../Components/Button/Button';
import { FaWhatsapp } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaPhone } from 'react-icons/fa';
import { FaMailBulk } from 'react-icons/fa';
import './ContactPage.css'

const ContactPage = () => {

  return (
    <>
      <div className='body'>
        <div>
          <p className='text'>
            <strong>
            </strong>
            <br />
          </p>
        </div>
        <div className='botones-container'>
          <Button
            url="https://wa.me/34685740233?text=Hola%2C%20estoy%20interesado%20en%20comprar%20vinos%20de%20El%20Abuelo%20Wine%20%F0%9F%8D%B7.%20Podr%C3%ADa%20darme%20m%C3%A1s%20informaci%C3%B3n%3F"
            text="685 740 233"
            Icon={FaWhatsapp}            
          />
          <Button
            url="tel:+34685740233"
            text="685 740 233 "
            Icon={FaPhone}
          />
          <Button
            url="https://www.instagram.com/el_abuelo_wine/"
            text="@ElAbueloWine"
            Icon={FaInstagram} 
             />
          <Button
            url="mailto:vinodelhoyo@gmail.com?subject=Informaciones%20de%20vinos&body=Hola%20estaba%20interesado%20en%20tener%20mas%20informaciones%20sobre%20vosotros."
            text="vinodelhoyo@gmail.com"
            Icon={FaMailBulk} 
          />
        </div>
      </div>
    </>
  )
}

export default ContactPage
